"use client"

import * as React from "react"
import { addDays, format } from "date-fns"
import { CalendarIcon } from "lucide-react"
import { DateRange } from "react-day-picker"

import { cn } from "../../components/ui/utils"
import { Button } from "../../components/ui/button"
import { Calendar } from "../../components/ui/calendar"
import {
	Popover,
	PopoverContent,
	PopoverTrigger,
} from "../../components/ui/popover"
import { useEffect } from "react"

interface TypesDataPicker {
	onPickerChange?: (date: any) => void;
}


const DatePickerWithRange: React.FC<TypesDataPicker> = (
	{onPickerChange}
) => {

	const [date, setDate] = React.useState<DateRange | undefined>({
		from: new Date(2025, 0, 20),
		to: addDays(new Date(2025, 0, 20), 20),
	})

	const setOption = (value: any) => {
		if (onPickerChange) {
			onPickerChange(value)
		}
		setDate(value);
	};

	return (
		<div className={cn("grid gap-2")}>
			<Popover modal={false} >
				<PopoverTrigger asChild>
					<Button
						id="date"
						variant={"outline"}
						className={cn(
							"w-[250px] rounded-[30px]  text-left font-normal justify-start gap-2",
							!date && "text-muted-foreground"
						)}
					>
						<CalendarIcon color="#000E4B" />
						{date?.from ? (
							date.to ? (
								<>
									{format(date.from, "LLL dd, y")} -{" "}
									{format(date.to, "LLL dd, y")}
								</>
							) : (
								format(date.from, "LLL dd, y")
							)
						) : (
							<span>Pick a date</span>
						)}
					</Button>
				</PopoverTrigger>
				<PopoverContent style={{ pointerEvents: 'all' }} className="w-auto p-0 bg-white z-[20000]" align="start"   >
					<Calendar
						classNames={{
							day_selected: "bg-zinc-500 text-white hover:bg-blue-600",
							day_range_middle: "bg-zinc-100 text-blue-800",
							day_range_start: "bg-zinc-500 text-white rounded-l-md",
							day_range_end: "bg-zinc-500 text-white rounded-r-md",
						}}
						initialFocus
						mode="range"
						defaultMonth={date?.from}
						selected={date}
						onSelect={setOption}
						numberOfMonths={2}
					/>
				</PopoverContent>
			</Popover>
		</div>
	)
}

export default DatePickerWithRange;
